<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      elevation="3"
      elevate-on-scroll
      height="80"
    >
    <router-link to="/">
      <base-img
        :src="require(`@/assets/logo2.png`)"
        contain
        max-width="180"
        width="100%"
      />
    </router-link>

      <v-spacer />

      <div
      class="hidden-md-and-down"
      v-for="(name, i) in items"
      :key="i"
      >
      <div v-if="name.items == 0">
        <div v-if="name.icon">
          <v-btn
            :to="name.to"
            :exact="name.title === 'Home'"
            :ripple="false"
            class="font-weight-bold ml-6"
            active-class="actbtn"
            text
            large
            color=primary
            @click="removeClicked()"
          >
            {{ name.title }}
            <v-icon
            right
            >
            {{ name.icon }}
            </v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            :to="name.to"
            :exact="name.title === 'Home'"
            :ripple="false"
            class="font-weight-bold ml-6"
            active-class="actbtn"
            text
            large
            color="primary"
            @click="removeClicked()"
          >
            {{ name.title }}
          </v-btn>
        </div>
      </div>
      <div v-else>
      <v-menu
      offset-y
      open-on-hover
      >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :ripple="false"
          class="font-weight-bold ml-6"
          active-class="actbtn"
          :class="clicked === name.title.toLowerCase() ? 'actbtn' : 'font-weight-bold ml-6'"
          text
          large
          v-bind="attrs"
          v-on="on"
          color="primary"
          :id="'menu-btn-'+name.title.toLowerCase()"
        >
          {{ name.title }}
          <v-icon
          dark
          right
          >
          mdi-arrow-down-drop-circle
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in name.items"
          :key="index"
        >
          <v-list-item-title>
            <v-btn
            :to="item.to"
            @click="addActiveClass(item.to)"
            text
            >
              {{ item.title }}
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      </div>
      </div>

      <v-app-bar-nav-icon
        class="hidden-lg-and-up hamburger-btn"
        @click="drawer = !drawer"
        x-large
      />
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      fixed
    >
      <v-list
        v-for="item in items"
        :key="item.title"
        nav
        shaped
      >
        <div v-if="item.items != 0">
          <v-list-group>
            <template #activator>
              <v-list-item-content>
                <v-list-item-title
                :id="item.id"
                v-text="item.title"
                />
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="child in item.items"
              :key="child.title"
              :to="child.to"
              :id="child.id"
              :exact="item.title === 'Home'"
            >
              <v-list-group
              sub-group
              no-action
              v-if="child.items != 0"
              >
                <template #activator>
                  <v-list-item-content>
                    <v-list-item-title
                    :id="child.id"
                    v-text="child.title"
                    />
                  </v-list-item-content>
                </template>
                <v-list-item
                v-for="schild in child.items"
                :key="schild.title"
                :to="schild.to"
                :id="schild.id"
                :exact="child.title === 'Home'"
              >
              <v-list-item-title
              :id="schild.id"
              >
              {{ schild.title }}</v-list-item-title>
              </v-list-item>
              </v-list-group>
              <v-list-item-title
              v-else
              :id="child.id"
              >
              {{ child.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
        <div v-else>
          <v-list-item
            :key="item.title"
            :to="item.to"
            :id="item.id"
            :exact="item.title === 'Home'"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>

  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    data: () => ({
      drawer: null,
      clicked: '',
      items: [
        {
          items: [],
          title: 'Home',
          to: '/',
        },
        {
          items: [],
          title: 'Call for Papers',
          to: '/cfp',
        },
        {
          items: [],
          title: 'Key Dates',
          to: '/key-dates',
        },
        {
          items: [],
          title: 'Committees',
          to: '/committee',
        },
        {
          items: [],
          title: 'Sponsors',
          to: '/sponsors',
        },
        {
          items: [],
          title: 'Venue',
          to: '/venue',
        },
        {
          items: [],
          title: 'Cusco Tour',
          to: '/cusco-tour',
        },
      ],
    }),
    methods: {
      addActiveClass(el) {
        var toClick = el.split("/")[1]
        var id_to_add = ""
        if (this.clicked !== '' && this.clicked !== toClick) {
          id_to_add = "menu-btn-" + this.clicked
          document.getElementById(id_to_add).children[0].classList.remove("actbtn")
        }
        this.clicked = el.split("/")[1]
        id_to_add = "menu-btn-" + this.clicked
        document.getElementById(id_to_add).children[0].classList.add("actbtn")
      },
      removeClicked() {
        var id_to_add = "menu-btn-" + this.clicked
        if (document.getElementById(id_to_add)) {
          document.getElementById(id_to_add).children[0].classList.remove("actbtn")
          this.clicked = ''
        }
      },
    },
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none

    .v-btn
      padding: 10px 5px
      font-size: 0.75rem !important
      opacity: 1 !important

    .actbtn
      background-color: #EE05F2
      color: white !important
      opacity: 1 !important

  .hamburger-btn .v-icon
    font-size: 36px !important
    filter: drop-shadow(0 0 0.6px currentColor)
</style>
